import { Outlet } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { SectionNav, type Section } from '../components/SectionNav';
import { WebhookSettings } from '../components/WebhookSettings';

/**
 * The two ways a publisher's own systems get at their subscribers, side by side.
 *
 * They are a pair rather than one page because they are read for different reasons: a key is
 * something somebody creates once and then looks up to see whether it is still in use, and the
 * webhook is where somebody goes when signups have stopped arriving. Both are org scoped, both
 * hand over a value that is shown once, and both belong to an owner, so they sit under one heading
 * in the settings list with a tab each.
 *
 * The third way out, a CSV, is on the subscribers screen under Email lists, where the subscribers
 * themselves are.
 */
const SECTIONS: readonly Section[] = [
  { to: '/settings/developers', label: 'API keys', end: true },
  { to: '/settings/developers/webhook', label: 'Newsletter webhook' },
];

export function Developers() {
  return (
    <>
      <SectionNav label="Developer sections" sections={SECTIONS} orientation="horizontal" />
      <Outlet />
    </>
  );
}

/** The webhook on its own tab, with the publisher and the reader's role read from the session. */
export function OrgWebhook() {
  const { org } = useAuth();

  return (
    <WebhookSettings
      orgId={org?.org_id ?? ''}
      orgName={org?.name ?? 'this publisher'}
      canEdit={org?.role === 'owner'}
    />
  );
}
